module.exports = __webpack_public_path__ + "static/logo-89715d2597ef040d0a7294f7459ca3b4.svg";